import { WidgetClass } from '../../models';
import { IWidget } from '../../widgets';

//TODO copy/paste from wtWidgetList
export function getWidgetClass(item: IWidget): WidgetClass {
    let error = (item.getError)
        ? item.getError()
        : null;
    if (!error) {
        error = item.error
            ? item.error
            : null;
    }
    let errorClass = '';
    if (error !== null && error !== undefined) {
        errorClass = error.classed;
    }
    const result: WidgetClass = {};
    if (errorClass) {
        result[errorClass] = true;
    }
    result['has-background-color'] = !!item.backgroundColor;
    return result;
}